export const livewireOffcanvas = () => {
    const templateElement = document.querySelector('#livewire-offcanvas');

    if (!templateElement) {
        return;
    }

    const bootstrapComponent = window.bootstrap.Offcanvas.getOrCreateInstance(templateElement);

    window.Livewire.on('show-offcanvas', () => {
        bootstrapComponent.show();
    });

    window.Livewire.on('hide-offcanvas', () => {
        bootstrapComponent.hide();
    });
};
